/*
 * Copyright (c) 2022
 * 
 * Created Date: Friday, September 30th 2022, 2:36:59 pm
 * Author: Muhammad Fajariansyah Ismail
 * 
 */

const Constant = {
    version: '1.9.0',
    baseApiURL: process.env.REACT_APP_API_URL,
    baseApiReportURL: process.env.REACT_APP_API_URL + '/report-api',
    interactiveMediaBaseUrl: process.env.REACT_APP_INTERACTIVE_URL,
    maxNumber: Number.MAX_SAFE_INTEGER,

    mediaQuery: {
        isMobile: '(max-width: 599px)'
    },

    courseRoleRepo: {
        TRAINER: 'Trainer',
        TRAINEE: 'Trainee',
    },

    courseStatus: {
        COMPLETED: 'completed',
        INPROGRESS: 'in-progress',
        UPCOMING: 'upcoming',
        INCOMPLETED: 'in-completed',
        DRAFT: 'draft',
        TODO: 'to-do',
        PUBLISHED: 'published',
        UNPUBLISHED: 'unpublished',
        SUBMITTED: 'submitted',
        DELETED: 'deleted',
        CLOSED: 'closed',
        SCHEDULED: 'scheduled'
    },

    smileStatus: {
        PUBLISHED: 'Published',
        UNPUBLISHED: 'Unpublished',
        DRAFT: 'Draft',
        COMPLETED: 'Completed',
        DUPLICATED: 'Duplicated',
        DELETED: 'Deleted'
    },

    highlightStatus: {
        HIGHLIGHTCHECK: 'highlight',
        HIGHLIGHTLABEL: 'common.highlight',
        UNHIGHLIGHTCHECK: 'unhighlight',
        UNHIGHLIGHTLABEL: 'common.unhighlight',
        NOTDEFINED: 'not defined'
    },

    role: {
        SUPERADMIN: 'Superadmin',
        ADMIN: 'Admin',
        ADMINBC: 'Admin BC',
        TRAINEE: 'Trainee',
        TRAINER: 'Trainer'
    },

    roleId: {
        SUPERADMIN: 4,
        ADMIN: 3,
        TRAINEE: 1,
        TRAINER: 2
    },

    roleSetting: {
        SUPERADMIN: 'ROLE_SUPER_ADMIN',
        ADMIN: 'ROLE_ADMIN',
        ADMINBC: 'ROLE_ADMIN_BC',
        TRAINEE: 'ROLE_TRAINEE',
        TRAINER: 'ROLE_TRAINER'
    },

    profileType: {
        EMPLOYEE: 'Employee',
        AGENT: 'Agent',
        BC: 'BC',
        DMTM: 'DMTM',
        CORPORATE: 'Corporate',
        MRI: 'MRI',
        AGENCY: 'AGENCY'
    },

    profileTypeId: {
        EMPLOYEE: 1,
        AGENT: 2,
        BC: 3,
        DMTM: 4,
        CORPORATE: 5,
        MRI: 6,
    },

    viewMode: {
        VIEW: 1,
        ADD: 2,
        EDIT: 3,
    },

    maxTextLength: {
        COMMON_DESCRIPTION: 500,
        COURSE_INFO_NAME: 100,
        COURSE_BATCH_NAME: 50,
        SUBJECT_MATTER_NAME: 100,
        SUBJECT_MATTER_DESCRIPTION: 1000,
        CHAPTER_NAME: 100,
        CHAPTER_DESCRIPTION: 1000
    },

    courseListStatus: [
        { id: 1, value: "all", label: "all" },
        { id: 2, value: "completed", label: "completed" },
        { id: 3, value: "incompleted", label: "incompleted" },
        { id: 4, value: "in-progress", label: "inProgress" },
        { id: 5, value: "upcoming", label: "upcoming" },
    ],

    courseListStatusForTrainer: [
        { id: 1, value: "all", label: "all" },
        { id: 2, value: "completed", label: "completed" },
        { id: 3, value: "incompleted", label: "incompleted" },
        { id: 4, value: "in-progress", label: "inProgress" },
        { id: 5, value: "upcoming", label: "upcoming" },
        { id: 6, value: "to-do", label: "todo" },
    ],

    dropdownFilterCourseList: [
        { id: 1, label: "filter.courseType" },
        { id: 2, label: "Program" },
        { id: 3, label: "filter.period" },
        { id: 4, label: "filter.courseResult" },
    ],

    dropdownFilterCertificationList: [
        { id: 2, label: "Program" },
        { id: 3, label: "filter.period" },
    ],

    categoryCourseValueFromService: {
        ELEARNING: 'e-learning',
        OFFLINE: 'offline-learning',
        VIRTUAL: 'virtual-learning',
    },

    dropdownFilterCategoryCourseList: [
        { id: 1, value: "", label: "common.all" },
        { id: 2, value: "e-learning", label: "E-Learning" },
        { id: 3, value: "virtual-learning", label: "Virtual" },
        { id: 4, value: "offline-learning", label: "Offline" }
    ],

    dropdownSortCourseList: [
        { id: 1, value: 1, label: 'filter.nameAZ' },
        { id: 2, value: 2, label: 'filter.nameZA' },
        { id: 3, value: 3, label: 'filter.newest' },
        { id: 4, value: 4, label: 'filter.latest' },
        { id: 5, value: 5, label: 'filter.newestSchedule' },
        { id: 6, value: 6, label: 'filter.latestSchedule' },
        { id: 7, value: 7, label: 'filter.shortestDuration' },
        { id: 8, value: 8, label: 'filter.longestDuration' },
        { id: 9, value: 9, label: 'filter.highlighted' },
        { id: 10, value: 10, label: 'filter.notHighlighted' },
    ],

    dropdownSortCertificationList: [
        { id: 1, value: 1, label: 'filter.nameAZ' },
        { id: 2, value: 2, label: 'filter.nameZA' },
        { id: 3, value: 3, label: 'filter.newest' },
        { id: 4, value: 4, label: 'filter.latest' },
        { id: 7, value: 7, label: 'filter.shortestDuration' },
        { id: 8, value: 8, label: 'filter.longestDuration' },
    ],

    mediaTypeRepo: {
        interactive: 'interactive',
        link: 'link',
        pdf: 'pdf',
        ppt: 'ppt',
        audio: 'audio',
        videoInternal: 'video-internal',
        videoExternal: 'video-external',
        image: 'image',
        none: 'none'
    },
    downloadCondition: {
        notAllowed: 0,
        afterCourse: 1,
        anytime: 2
    },
    maxUploadMedia: {
        image: 62914560,
        video: 62914560,
        interactive: 200 * 1024 * 1024
    },
    typeProfile: {
        EMPLOYEE: 1,
        AGENT: 2,
        BC: 3,
        DMTM: 4,
        CORPORATE: 5,
        MRI: 6,
    },

    dropdownFilterMyCertificate: [
        { id: 1, label: "Program" },
        { id: 2, label: "filter.period" },
    ],

    dropdownSortMySmileMyCertificate: [
        { id: 1, value: 1, label: 'filter.nameAZ' },
        { id: 2, value: 2, label: 'filter.nameZA' },
        { id: 3, value: 3, label: 'filter.newest' },
        { id: 4, value: 4, label: 'filter.latest' },
        { id: 5, value: 5, label: 'filter.shortestDuration' },
        { id: 6, value: 6, label: 'filter.longestDuration' }
    ],

    keyValueSetting: {
        ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
        ROLE_ADMIN: "ROLE_ADMIN",
        ROLE_TRAINEE: "ROLE_TRAINEE",
        ROLE_TRAINER: "ROLE_TRAINER"
    },

    typeFeedback: {
        "COURSE": "course",
        "SMILE": "smile",
    },

    typeQuestionFeedback: {
        "MULTIPLE-CHOICE": "multiple-choice",
        "TRUE-FALSE": "true-false",
        "ESSSAY": "essay",
    },

    mediaPlaybackConfig: {
        maxPlaybackRate: 3,
        increaseStep: 1
    },

    addCourse: {
        sort: {
            CREATED_ON_ASC: 1,
            CREATED_ON_DESC: 2,
            NAME_ASC: 3,
            NAME_DESC: 4,
        }
    },

    form: {
        smileAssessmentMinScore: {
            max: 99
        },
        smileAssessmentDuration: {
            max: 999
        },
        smileAssessmentMaxRepeat: {
            max: 99
        },
        courseChapterTestDuration: {
            max: 999
        },
        courseChapterTestMinScore: {
            max: 99
        },
        courseAssessmentTestMinScore: {
            max: 99
        },
        courseAssessmentTestDuration: {
            max: 999
        },
        courseAssessmentTestMaxRepeat: {
            max: 99
        },
        coursePretestMinScore: {
            max: 99
        },
        coursePretestDuration: {
            max: 999
        },
        courseMinQuota: {
            max: 9999999999
        },
        courseMaxQuota: {
            max: 9999999999
        },
        courseBatchQuota: {
            min: 9999999999,
            max: 9999999999
        },
        courseSubjectMatterQuizDuration: {
            max: 999
        },
        courseSubjectMatterMinScore: {
            max: 99
        }
    },

    certificatePlaceholder: [
        'Trainee Name',
        'Certification Number',
        'Start Course Period',
        'End Course Period',
        'Course/Smile Name',
        'Certification Issue Date'
    ],

    chapterStatus: {
        "INCOMPLETE": "incompleted",
        "COMPLETE": "completed"
    },

    apiTimeout: (1000*60)*30,

    assets: {
        logo: {
            primary: '/images/luna_logo.svg?msig',
            primary_white: '/images/luna_2x_white.svg?msig',
            footer: '/images/msig_logo.svg?msig'
        }
    },

    chartColor: {
        completed: '#252560',
        inProgress: '#E2242B',
        notStarted: '#D1D1DE',
        inCompleted: '#565556',
        
    },

    pdfViewer: {
        readDuration: 2, //in seconds
    },

    biometricVerification: {
        maxRetry: 3,
        otpDuration: 180,
        viewState: {
            consent: 'consent',
            sending: 'sending',
            failed: 'failed',
            biometricNotAvailable: 'biometric-not-available',
            serviceNotAvailable: 'service-not-available',
            networkError: 'network-error'
        }
    },

    userInfoTabType: {
        GENERAL: 'general',
        MYPERFORMANCE_REPORT: 'myperformance-report'
    }
}

export default Constant
